import React, { useEffect, useState } from 'react';
import { Link, useNavigate } from 'react-router-dom';
import { motion, AnimatePresence } from 'framer-motion';
import { Menu, X } from 'lucide-react';
import { BillvastLogo } from '../ui/BillvastLogo';
export const Navbar: React.FC = () => {
  const [isScrolled, setIsScrolled] = useState(false);
  const [isMobileMenuOpen, setIsMobileMenuOpen] = useState(false);
  const navigate = useNavigate();
  useEffect(() => {
    const handleScroll = () => {
      setIsScrolled(window.scrollY > 20);
    };
    window.addEventListener('scroll', handleScroll);
    return () => window.removeEventListener('scroll', handleScroll);
  }, []);
  const scrollToSection = (id: string) => {
    const element = document.getElementById(id);
    if (element) {
      element.scrollIntoView({
        behavior: 'smooth'
      });
    }
    setIsMobileMenuOpen(false);
  };
  return <motion.header initial={{
    y: -100
  }} animate={{
    y: 0
  }} transition={{
    duration: 0.5,
    ease: 'easeOut'
  }} className={`fixed top-0 left-0 right-0 z-50 transition-all duration-300 ${isScrolled ? 'bg-white/80 backdrop-blur-md shadow-sm py-3' : 'bg-transparent py-5'}`} data-id="element-135">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 flex items-center justify-between" data-id="element-136">
        {/* Logo */}
        <Link to="/" className="flex items-center z-50" data-id="element-137">
          <BillvastLogo size="lg" data-id="element-138" />
        </Link>

        {/* Desktop Nav */}
        <nav className="hidden md:flex items-center gap-8" data-id="element-139">
          <button onClick={() => window.scrollTo({
          top: 0,
          behavior: 'smooth'
        })} className="text-sm font-medium text-brand-text-dark hover:text-brand-primary transition-colors" data-id="element-140">
            Home
          </button>
          <button onClick={() => scrollToSection('solutions')} className="text-sm font-medium text-brand-accent hover:text-orange-500 transition-colors" data-id="element-141">
            Crowdfunding
          </button>
          <button onClick={() => scrollToSection('solutions')} className="text-sm font-medium text-brand-text-dark hover:text-brand-primary transition-colors" data-id="element-142">
            Exchange
          </button>
          <button onClick={() => scrollToSection('solutions')} className="text-sm font-medium text-brand-text-dark hover:text-brand-primary transition-colors" data-id="element-143">
            Bills & Facility
          </button>
          <button onClick={() => scrollToSection('how-it-works')} className="text-sm font-medium text-brand-text-dark hover:text-brand-primary transition-colors" data-id="element-144">
            How It Works
          </button>
          <button onClick={() => scrollToSection('why-billvast')} className="text-sm font-medium text-brand-text-dark hover:text-brand-primary transition-colors" data-id="element-145">
            Company
          </button>
        </nav>

        {/* CTA */}
        <div className="hidden md:flex items-center gap-4" data-id="element-146">
          <button onClick={() => navigate('/login')} className="text-sm font-medium text-brand-text-dark hover:text-brand-primary transition-colors" data-id="element-147">
            Log in
          </button>
          <button onClick={() => navigate('/login')} className="bg-brand-accent hover:bg-orange-400 text-white px-6 py-2.5 rounded-xl font-semibold transition-colors shadow-sm text-sm" data-id="element-148">
            Launch App
          </button>
        </div>

        {/* Mobile Menu Toggle */}
        <button className="md:hidden z-50 text-brand-text-dark p-2" onClick={() => setIsMobileMenuOpen(!isMobileMenuOpen)} data-id="element-149">
          {isMobileMenuOpen ? <X size={24} data-id="element-150" /> : <Menu size={24} data-id="element-151" />}
        </button>
      </div>

      {/* Mobile Menu */}
      <AnimatePresence data-id="element-152">
        {isMobileMenuOpen && <motion.div initial={{
        opacity: 0,
        y: -20
      }} animate={{
        opacity: 1,
        y: 0
      }} exit={{
        opacity: 0,
        y: -20
      }} className="absolute top-full left-0 right-0 bg-white shadow-xl border-t border-gray-100 p-4 flex flex-col gap-4 md:hidden" data-id="element-153">
            <button onClick={() => scrollToSection('solutions')} className="text-left py-3 px-4 rounded-xl hover:bg-orange-50 font-medium text-brand-accent" data-id="element-154">
              Crowdfunding
            </button>
            <button onClick={() => scrollToSection('solutions')} className="text-left py-3 px-4 rounded-xl hover:bg-gray-50 font-medium text-brand-text-dark" data-id="element-155">
              Exchange
            </button>
            <button onClick={() => scrollToSection('solutions')} className="text-left py-3 px-4 rounded-xl hover:bg-gray-50 font-medium text-brand-text-dark" data-id="element-156">
              Bills & Facility
            </button>
            <button onClick={() => scrollToSection('how-it-works')} className="text-left py-3 px-4 rounded-xl hover:bg-gray-50 font-medium text-brand-text-dark" data-id="element-157">
              How It Works
            </button>
            <button onClick={() => scrollToSection('why-billvast')} className="text-left py-3 px-4 rounded-xl hover:bg-gray-50 font-medium text-brand-text-dark" data-id="element-158">
              Company
            </button>
            <div className="h-px bg-gray-100 my-2" data-id="element-159" />
            <button onClick={() => navigate('/login')} className="w-full py-3 px-4 rounded-xl font-medium text-brand-text-dark border border-gray-200" data-id="element-160">
              Log in
            </button>
            <button onClick={() => navigate('/login')} className="w-full bg-brand-accent text-white py-3 px-4 rounded-xl font-semibold" data-id="element-161">
              Launch App
            </button>
          </motion.div>}
      </AnimatePresence>
    </motion.header>;
};